import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getStateParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'stateParts';

export const statePartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearStateParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getStateParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearStateParts } = statePartsSlice.actions;

export const stateParts = statePartsSlice.reducer;
